import { FormItemRule, FormRules } from "naive-ui";
import { emailRegexValidator, urlRegexValidator, onlyAllowNumberValidator } from "@/ts/validation";

export const loginRules : FormRules = {
    email: [{
        required: true,
        validator(rule: FormItemRule, value: string) {
            if (!value) {
                return new Error('Email is required')
            } else if (!emailRegexValidator.test(value)) {
                return new Error('Email has incorrect format')
            }
            return true
        },
        trigger: ['input', 'blur']
    }],
    password: [{
        required: true,
        message: 'Password is required',
        trigger: ['input', 'blur']
    }]
}

export const projectFormRules : FormRules = {
    role_title : [{
        required: true,
        message: "Role title is required",
        trigger: ['input', 'blur']
    }],
    years_of_experience : [{
        required: true,
        message: "Years of experience is required",
        trigger: ['blur', 'change']
    }],
    usd_hourly_rate : [{
        required: true,
        message: "Budgeted hourly rate is required",
        trigger: ['blur', 'change']
    }],
    skills : [{
        validator(rule: FormItemRule, value: string) {
            if (value.length <= 0) {
                return new Error('Main skills are required')
            } else if (value.length > 3) {
                return new Error('Select a maximum of 3 skills')
            }
            return true
        },
        trigger: ['blur', 'change']
    }],
    complementary_skills : [{
        validator(rule: FormItemRule, value: string) {
            if (value.length <= 0) {
                return new Error('Secondary skills are required')
            } else if (value.length > 3) {
                return new Error('Select a maximum of 3 skills')
            }
            return true
        },
        trigger: ['blur', 'change']
    }],
    job_description_link : [{
        required: true,
        validator(rule: FormItemRule, value: string) {
            if (value && !urlRegexValidator.test(value)) {
                return new Error('Job description link has incorrect format')
            }
            return true
        },
        trigger: ['input', 'blur']
    }],
}

export const settingsFormRules : FormRules = {
    name : [{
        required: true,
        message: "Name is required",
        trigger: ['input', 'blur']
    }],
    email: [{
        required: true,
        validator(rule: FormItemRule, value: string) {
            if (!value) {
                return new Error('Email is required')
            } else if (!emailRegexValidator.test(value)) {
                return new Error('Email has incorrect format')
            }
            return true
        },
        trigger: ['input', 'blur']
    }],
    job_title : [{
        required: true,
        message: "Job Title is required",
        trigger: ['input', 'blur']
    }],
    company : [{
        required: true,
        message: "Company is required",
        trigger: ['input', 'blur']
    }],
    phone_number : [{
        required: true,
        validator(rule: FormItemRule, value: string) {
            if (!onlyAllowNumberValidator(value)) {
                return new Error('Direct Phone Number must not contain characters')
            } else if (!value) {
                return new Error('Direct Phone Number is required')
            }
            return true
        },
        trigger: ['input', 'blur']
    }],
}